export const permissions = {
  defaultRedirectUrl: '/',
  defaultPermPrefix: 'dynamic_config_ui',
  routes: [['/', 'read:assets']]
};
export const appName = 'Dynamic Config UI';
